<template>
  <div v-loading="loading">
    <Form>
     <!-- <FormItem :label="l('JIHUAMINGCHENG')">{{item.name}}</FormItem>
      <Row>
        <Col span="6">
          <FormItem :label="l('NIANDU')">{{item.year}}{{l("NIAN")}}</FormItem>
        </Col>
        <Col span="6">
          <FormItem :label="l('YUEFEN')">{{item.month}}{{l("YUE")}}</FormItem>
        </Col>
        <Col span="6">
          <FormItem :label="l('SUOSHUZUZHI')">{{item.domainName}}</FormItem>
        </Col>
        <Col span="6">
          <FormItem :label="l('GUANLIWEIDU')">{{item.dimensionNames}}</FormItem>
        </Col>
      </Row>
      <Row>
        <Col span="6">
          <FormItem :label="l('KECHENGMULU')">{{item.courseTypeName}}</FormItem>
        </Col>
        <Col span="6">
          <FormItem :label="l('PEIXUNNEIRONG')">{{item.name}}</FormItem>
        </Col>
        <Col span="6">
          <FormItem :label="l('PEIXUNDUIXIANG')">{{item.trainObject}}</FormItem>
        </Col>
        <Col span="6">
          <FormItem :label="l('PEIXUNXINGSHI')">{{item.trainFormName}}</FormItem>
        </Col>
      </Row>
      <Row>
        <Col span="6">
          <FormItem :label="l('PEIXUNLEIXING')">{{item.trainTypeName}}</FormItem>
        </Col>
        <Col span="6">
          <FormItem :label="l('KAOHEFANGSHI')">{{item.testMethodName}}</FormItem>
        </Col>
        <Col span="12">
          <FormItem :label="l('PEIXUNDIZHI')">{{item.trainAddress}}</FormItem>
        </Col>
      </Row>
      <Row>
        <Col span="6">
          <FormItem :label="l('YUSUANHEJI')">{{item.expenseBudget}}</FormItem>
        </Col>
        <Col span="6">
          <FormItem :label="l('RENCIHEJI')">{{item.expectedPeoples}}</FormItem>
        </Col>
        <Col span="6">
          <FormItem :label="l('KESHIHEJI')">{{item.expectedClassHours}}</FormItem>
        </Col>
        <Col span="6">
          <FormItem :label="l('NIFUXUEFEN')">{{item.credit || l("ZANWU")}}</FormItem>
        </Col>
      </Row>
      <Row>
        <Col span="6">
          <FormItem :label="l('PEIXUNJIBIE')">{{item.trainingLevel || l("ZANWU") }}</FormItem>
        </Col>
        <Col span="6">
          <FormItem :label="l('PEIXUNZHUYAONEIRONG')">{{item.trainingContent}}</FormItem>
        </Col>
        <Col span="6">
          <FormItem :label="l('GUANLIANNIANDUJIHUA')">{{item.yearName || l("ZANWU")}}</FormItem>
        </Col>
        <Col span="6">
          <FormItem :label="l('SHISHIBUMEN')">{{item.orgName}}</FormItem>
        </Col>
      </Row>
      <Row>
        <Col span="24">
          <FormItem :label="l('JIANGSHI')">{{item.teacherNames }}</FormItem>
        </Col>
      </Row>-->
    </Form>
  </div>
</template>

<script>
export default {
  name: "monthPlan",
  props: ["id"],
  data() {
    return {
      loading: false,
      item: {}
    };
  },
  methods: {
    _fetch(id) {
      if (id) {
        this.loading = true;
        this.http
          .request("sys/trainClassAttendance/leaveInfo", { id: id })
          .then(result => {
            this.item = result.item;
          })
          .finally(() => (this.loading = false));
      }
    }
  },
  created: function() {
    this._fetch(this.id);
  }
};
</script>



// WEBPACK FOOTER //
// attendanceLeaveAudit.vue?0832603c